// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__Zc0FD","spinner":"styles_spinner__MfQb-"};